// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.access-request-form {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  max-width: 480px;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.access-request-tabs {
  display: flex;
  gap: 0.5rem;
  border-bottom: 1px solid #e4edf3;
}

.access-request-tab {
  padding: 0.5rem 0.75rem;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #5f6b7a;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
}

.access-request-tab.active {
  border-bottom-color: #0073ab;
  color: #0073ab;
}

.access-request-fields {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.access-request-honeypot {
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.access-request-choice-hint {
  margin: 0;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  background: #f0f7fb;
  color: #35495e;
  font-size: 0.78rem;
  line-height: 1.3;
}

.access-request-divider {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.access-request-divider-line {
  flex: 1 1;
  height: 1px;
  background: #e4edf3;
}

.access-request-divider-text {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #9aa6b2;
}

.access-request-register {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.6rem 0;
  border-top: 1px dashed #e4edf3;
  border-bottom: 1px dashed #e4edf3;
  font-size: 0.85rem;
  color: #5f6b7a;
}

.access-request-register a {
  color: #0073ab;
  font-weight: 600;
  text-decoration: none;
}

.access-request-register a:hover {
  text-decoration: underline;
}

.access-request-status {
  margin: 0;
  padding: 0.6rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
}

.access-request-status--success {
  background: #e6f4ea;
  color: #1e7d3c;
}

.access-request-status--error {
  background: #fdecea;
  color: #b3261e;
}

.access-request-actions {
  display: flex;
  width: 100%;
  gap: 0.5rem;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/Components/AccessRequest/AccessRequestForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B","sourcesContent":[".access-request-form {\n  display: flex;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 480px;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1rem;\n}\n\n.access-request-tabs {\n  display: flex;\n  gap: 0.5rem;\n  border-bottom: 1px solid #e4edf3;\n}\n\n.access-request-tab {\n  padding: 0.5rem 0.75rem;\n  border: none;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: #5f6b7a;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.access-request-tab.active {\n  border-bottom-color: #0073ab;\n  color: #0073ab;\n}\n\n.access-request-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.access-request-honeypot {\n  position: absolute;\n  left: -9999px;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n}\n\n.access-request-choice-hint {\n  margin: 0;\n  padding: 0.5rem 0.75rem;\n  border-radius: 6px;\n  background: #f0f7fb;\n  color: #35495e;\n  font-size: 0.78rem;\n  line-height: 1.3;\n}\n\n.access-request-divider {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.access-request-divider-line {\n  flex: 1;\n  height: 1px;\n  background: #e4edf3;\n}\n\n.access-request-divider-text {\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  color: #9aa6b2;\n}\n\n.access-request-register {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  padding: 0.6rem 0;\n  border-top: 1px dashed #e4edf3;\n  border-bottom: 1px dashed #e4edf3;\n  font-size: 0.85rem;\n  color: #5f6b7a;\n}\n\n.access-request-register a {\n  color: #0073ab;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.access-request-register a:hover {\n  text-decoration: underline;\n}\n\n.access-request-status {\n  margin: 0;\n  padding: 0.6rem 0.75rem;\n  border-radius: 6px;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.access-request-status--success {\n  background: #e6f4ea;\n  color: #1e7d3c;\n}\n\n.access-request-status--error {\n  background: #fdecea;\n  color: #b3261e;\n}\n\n.access-request-actions {\n  display: flex;\n  width: 100%;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
